<template>
  <div class="contacts-form-wrapper">
    <div
      class="contacts-form-heading"
      v-if="props?.title || props.contactsList?.length"
    >
      <PagesContactsContactsList
        :contacts="props.contactsList"
        :is-small="formType === 'careers'"
        class="show-for-large"
      />
    </div>

    <div class="contacts-form-content">
      <div
        v-if="props.intro"
        class="contacts-form-intro text-corpo-l is-xlight p-bottom-xl-1"
        v-html="props.intro"
      />

      <img
        class="hide-for-large p-bottom-xl-1"
        src="@/assets/img/logos/logo-pv.svg"
        :alt="'Logo Proposta Vini'"
      />
      
      <header
        v-if="props.title"
        class="contacts-form-header text-corpo-xxl p-bottom-m-1"
        v-html="props.title"
      />

      <ContactFormContatti
        v-if="formType === 'contacts'"
        :cta-label="props.ctaLabel"
        @form-sent="handleFormSent('contacts')"
        @form-error="handleFormError('contacts')"
      />
      <ContactFormCareers
        v-if="formType === 'careers'"
        @form-sent="handleFormSent('careers')"
        @form-error="handleFormError('careers')"
      />
    </div>
  </div>
  <PagesContactsContactsList
    :contacts="props.contactsList"
    class="hide-for-large m-top-l-1"
  />
</template>

<script setup>
const localePath = useLocalePath()
const router = useRouter()

const props = defineProps({
  title: String,
  intro: String,
  ctaLabel: String,
  contactsList: {
    type: Array,
    default: () => [],
  },
  formType: {
    type: String,
    default: 'contacts',
  },
})

const formContact = ref(null)

const handleFormSent = (type) => {
  const pageTarget =
    type === 'contacts'
      ? 'contatti-form-success'
      : 'lavora-con-noi-form-success'
  router.push(localePath({ name: pageTarget }))
}

const handleFormError = () => {
  const pageTarget =
    type === 'contacts'
      ? 'contatti-form-failure'
      : 'lavora-con-noi-form-failure'
  router.push(localePath({ name: pageTarget }))
}
</script>

<style lang="scss">
@import './style.scss';
</style>
